import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap';
import { SendCandidateOutreachEmailModule } from 'src/app/shared/send-candidate-outreach-email/send-candidate-outreach-email.module';
import { UploadReqStepResultsComponent } from './upload-req-step-results.component';

@NgModule({
  declarations: [UploadReqStepResultsComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    SendCandidateOutreachEmailModule
  ],
  exports: [UploadReqStepResultsComponent],
  entryComponents: [UploadReqStepResultsComponent]
})
export class UploadReqStepResultsModule { }
